import script from "./NavFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./NavFooter.vue?vue&type=script&setup=true&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=31e72f84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e72f84"]])

export default __exports__